import { loadOrganizations, Organization } from "@genai/organization";
import { loadCollections } from '../../collection/loaders';
import { Collection } from "../../collection/model";
import { ApiAssistant, Assistant, AssistantId } from "../model";
import { toAssistant } from "../src/toAssistant";
import { httpClient, postProcessUpsert } from "@genai/http-client";
import { loadUser, User } from '@genai/user';

export interface LoaderData {
  assistants?: Assistant[];
  collections?: Collection[];
  organizations?: Organization[];
  ragChatModes?: string[];
  models?: string[];
  postProcessingStrategies?: string[];
  distanceMetrics?: string[];
  user: User;
}

export const loadAssistants = () =>
    httpClient("/assistants", {
      method: "GET",
    })
    .then(postProcessUpsert<ApiAssistant[]>)
    .then((assistants) => assistants.map(toAssistant));

export const loadAssistant = (assistantId: AssistantId) =>
httpClient(`/assistants/${assistantId}`, {
  method: "GET",
})
  .then(postProcessUpsert<ApiAssistant>)
  .then(toAssistant);

export const loadRagChatModes = () =>  httpClient("/enums/rag-chat-modes", {
    method: "GET",
  }).then(postProcessUpsert<string[]>);

export const loadModels = () => httpClient("/enums/llm-models", {
    method: "GET",
  }).then(postProcessUpsert<string[]>);

export const loadPostProcessingStrategies = () =>
    httpClient("/enums/post-processing-strategies", {
      method: "GET",
    }).then(postProcessUpsert<string[]>);

export const loadDistanceMetrics = () =>
    httpClient("/enums/distance-metrics", {
      method: "GET",
    }).then(postProcessUpsert<string[]>);

export const assistantPageLoader = async (): Promise<LoaderData> => {
  const assistants = await loadAssistants();
  const collections = await loadCollections();
  const organizations = await loadOrganizations();
  const ragChatModes = await loadRagChatModes();
  const models = await loadModels();
  const postProcessingStrategies = await loadPostProcessingStrategies();
  const distanceMetrics = await loadDistanceMetrics();
  const user = await loadUser();

  return {
    assistants,
    collections,
    organizations,
    ragChatModes,
    models,
    postProcessingStrategies,
    distanceMetrics,
    user,
  };
};
